// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/c0257ae35d8101833766.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"299c88924ffcf00c8159","265":"e28e5d854889cfa70169","266":"153c6681a2348ec740a2"}[chunkId] + ".chunk.js";
};